export default __webpack_public_path__ + "static/nDreams_Studio_White-00c599f165be410d2a6b05ffc1b8c49f.png";